import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { AppRoutingModule, AppRoutes } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { ContentLayoutComponent } from './layouts/content-layout/content-layout.component';
import { NavbarModule } from './layouts/landing-layouts/navbarLanding/navbar.module';
import { FooterModule } from './layouts/landing-layouts/footerLanding/footer.module';
import { RouterModule } from '@angular/router';
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { ToastrModule } from 'ngx-toastr';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';

import { SidebarModule } from './layouts/main-layouts/sidebarMain/sidebar.module';
import { NavbarMainModule } from './layouts/main-layouts/navbarMain/navbar.module';
import { FooterMainModule } from './layouts/main-layouts/footerMain/footer.module';
import { MaterialModule } from './shared/material/material.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ExcelService } from './shared/material/excel.service';
import { ConfirmDialogComponent } from './shared/confirm-dialog/confirm-dialog.component';
import { SelectParkingDialogComponent } from './shared/select-parking-dialog/select-parking-dialog.component';
import { MatFormFieldModule, MatSelectModule } from '@angular/material';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxMatDatetimePickerModule, NgxMatNativeDateModule, NgxMatTimepickerModule } from '@angular-material-components/datetime-picker';
import { HttpRequestInterceptor } from './core/interceptors/http-request.interceptor';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    AuthLayoutComponent,
    ContentLayoutComponent,
    AdminLayoutComponent,
    ConfirmDialogComponent,
    SelectParkingDialogComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    NavbarModule,
    FooterModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    NgbModule,
    MaterialModule,
    RouterModule.forRoot(AppRoutes),
    ToastrModule.forRoot(),
    SidebarModule,
    NavbarMainModule,
    FooterMainModule,
    MatSelectModule,
    MatFormFieldModule,
    NgSelectModule,
    NgxMatDatetimePickerModule,
    NgxMatTimepickerModule,
    NgxMatNativeDateModule,
  ],
  providers: [
    ExcelService,
    { provide: HTTP_INTERCEPTORS, useClass: HttpRequestInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
  entryComponents: [
    ConfirmDialogComponent,
    SelectParkingDialogComponent
  ],
})
export class AppModule { }
